import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import IncomeAndExpenditure from "../components/transparency-reports/IncomeAndExpenditure";
import { Select } from "antd";
import PageHeader from "../components/PageHeader";
import { useTranslation } from "react-i18next";
import VillageIllustration from "../components/VillageIllustration";
import axiosInstance from "../services/axios";

const TransparencyReports = () => {
  const { i18n } = useTranslation();
  const [financialYears, setFinancialYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const lang = i18n.language;

  useEffect(() => {
    let mounted = true;
    const fetchFinancialYears = async () => {
      try {
        const res = await axiosInstance.get("/financial-years");
        if (!mounted) return;
        const data = res.data || [];
        if (Array.isArray(data) && data.length > 0) {
          setFinancialYears(data);
          // Default to 2025-2026, fallback to first year
          const defaultYear = data.find((y) => y.year === "2025-2026" || y.name === "2025-2026") || data[0];
          setSelectedYear(defaultYear);
        }
      } catch (err) {
        console.error("Failed to load financial years:", err);
      }
    };
    fetchFinancialYears();
    return () => { mounted = false; };
  }, []);

  // Build select options from API data
  const financialYearOptions = financialYears.map((year) => ({
    value: year.id || year.year,
    label: (
      <span>
        {lang === "en"
          ? `Financial Year ${year.year || year.name}`
          : `आर्थिक वर्ष ${year.year || year.name}`}
      </span>
    ),
  }));

  const content = {
    en: {
      homepage: "Homepage",
      title: "Village Budget",
      description: "Explore our ongoing development initiatives, completed projects, and government schemes designed to improve rural infrastructure and community welfare.",
      financialYearPlaceholder: "Select Financial Year",
    },
    mr: {
      homepage: "मुख्यपृष्ठ",
      title: "अर्थ संकल्प",
      description: "येथे, तुम्ही ग्रामपंचायतीच्या चालू विकास योजना, पूर्ण झालेले प्रकल्प आणि शासनाच्या विविध योजनांमधील अर्थ, उत्पन्न आणि खर्चाचे विश्लेषण पाहू शकता.",
      financialYearPlaceholder: "आर्थिक वर्ष निवडा",
    },
  };

  const currentContent = content[lang] || content.mr;

  const handleYearChange = (value) => {
    const year = financialYears.find((y) => (y.id || y.year) === value);
    setSelectedYear(year);
  };

  return (
    <>
      <div className="bg-image-section">
        <div className="flex flex-col gap-3 section-padding">
          <PageHeader
            breadcrumb={[
              <Link key="home" to="/">{currentContent.homepage}</Link>,
              <span key="transparency-reports">{currentContent.title}</span>,
            ]}
            title={currentContent.title}
            description={currentContent.description}
            actions={
              <div className="flex flex-md-row flex-column gap-3 w-100">
                <Select
                  className="min-w-40"
                  placeholder={currentContent.financialYearPlaceholder}
                  options={financialYearOptions}
                  value={selectedYear?.id || selectedYear?.year}
                  onChange={handleYearChange}
                  style={{ height: 35 }}
                />
                <button className="bg-[var(--color-primary)] hover:bg-[var(--color-primary-dark)] text-white px-4 py-2 rounded-md flex justify-center items-center gap-2 transition-colors w-full sm:w-auto">
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 16l-6-6h4V4h4v6h4l-6 6zm-8 4h16v2H4v-2z" />
                  </svg>
                  {lang === "en" ? "Download Report" : "अहवाल डाउनलोड करा"}
                </button>
              </div>
            }
          />
          <div className="flex flex-col gap-6">
            <IncomeAndExpenditure financialYear={selectedYear} />
          </div>
        </div>
      </div>
      <VillageIllustration />
    </>
  );
};

export default TransparencyReports;
